import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dialog, Tooltip, IconButton } from '@material-ui/core'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { COLORES } from '../../../../config/colores'
import DialogView from '../../../Dialogos/DialogView'
import PlanDeEmbarqueView from '../../components/planDeEmbarque/PlanDeEmbarqueView'
import { getPlanDeEmbarque, eliminarPlanDeEmbarque } from '../../actions/PlanDeEmbarqueActions'
import TablaPlanDeEmbarqueBodegas from './TablaPlanDeEmbarqueBodegas'

function PlanDeEmbarque (props) {
  const { anuncio } = props
  const [open, setOpen] = useState(false)

  useEffect(() => {
    getPlanDeEmbarque(anuncio.fechaPlanDeEmbarque)
  }, [anuncio])

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const handleDelete = () => {
    props.eliminarPlanDeEmbarque(anuncio.fechaPlanDeEmbarque, anuncio.nombreCorto, anuncio.fechaAnuncio)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          title='Plan de embarque'
          content={<>
            <PlanDeEmbarqueView anuncio={anuncio} handleDelete={handleDelete} />
            <TablaPlanDeEmbarqueBodegas fecha={anuncio.fechaPlanDeEmbarque} buque={anuncio.nombreCorto} />
          </>}
        />
      </Dialog>
      <Tooltip title={'Editar plan de embarque'} >
        <IconButton onClick={handleOpen} style={{ margin: '0 auto', width: '100%', outline: 'none' }}>
          <AssignmentIcon style={{ outline: 'none', color: COLORES.blue.primary }} />
        </IconButton>
      </Tooltip>

    </>
  )
}

const mapStateToProps = (state) => ({
  planDeEmbarque: state.buque.planDeEmbarque
})

const mapActionsToProps = {
  eliminarPlanDeEmbarque,
  getPlanDeEmbarque
}

export default connect(mapStateToProps, mapActionsToProps)(PlanDeEmbarque)
